import Header from "../components/Header"
import EventGallery from "../components/EventGallery"
import Footer from "../components/Footer"

import "./GalleryPage.css"

export default function GalleryPage() {
  return (
    <main className="gallery-main">

      <Header />
      <EventGallery />
      <Footer />
    </main>
  )
}
